import api from '../api/axiosInstance';

export const productService = {
  getByProductType: (productTypeName: string) => api.get(`/api/product/types/${productTypeName}/product-lines`),
  getAllProductLines: () => api.get<{ name: string }[]>('/api/product/product-lines'),
};
